import request from '@/utils/request'


// 查询文章列表
export function listArticle(query) {
  return request({
    url: '/article/article/list',
    method: 'get',
    params: query
  })
}

// 查询文章分页
export function pageArticle(query) {
  return request({
    url: '/article/article/page',
    method: 'get',
    params: query
  })
}

// 查询文章详细
export function getArticle(data) {
  return request({
    url: '/article/article/detail',
    method: 'get',
    params: data
  })
}

// 新增文章
export function addArticle(data) {
  return request({
    url: '/article/article/add',
    method: 'post',
    data: data
  })
}

// 修改文章
export function updateArticle(data) {
  return request({
    url: '/article/article/edit',
    method: 'post',
    data: data
  })
}

// 删除文章
export function delArticle(data) {
  return request({
    url: '/article/article/delete',
    method: 'post',
    data: data
  })
}
